import React, { useEffect, useState } from "react";
import StaffRegistrationFormShort from "../../components/forms/StaffRegistrationFormShort";
import { db } from "../../firebase";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { useAuth } from "../../context/AuthContext";
import { getUserDocId } from "../../utils/userDocId";

export default function StaffRegistrationShortPage() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [existingDoc, setExistingDoc] = useState(null);

  useEffect(() => {
    if (!user) return;
    const fetchDoc = async () => {
      const userId = getUserDocId(user);
      const ref = doc(db, "users", userId, "complianceDocs", "staffRegistration");
      const snap = await getDoc(ref);
      if (snap.exists()) setExistingDoc({ id: snap.id, ...snap.data() });
      setLoading(false);
    };
    fetchDoc();
  }, [user]);

  const handleSubmit = async (data) => {
    if (!user) return;
    const userId = getUserDocId(user);

    await setDoc(
      doc(db, "users", userId, "complianceDocs", "staffRegistration"),
      {
        ...data,
        name: "Staffing Registration Form",
        renewal: "As Required",
        status: "submitted",
        verified: existingDoc?.verified || false,
        lastUpdated: serverTimestamp(),
      },
      { merge: true }
    );

    alert("Registration form submitted.");
  };

  if (loading) {
    return <div style={{ padding: 20 }}>Loading…</div>;
  }

  // 🔒 If admin has verified, don’t allow editing
  if (existingDoc?.verified) {
    return (
      <div style={{ padding: 20, maxWidth: 800, margin: "0 auto" }}>
        <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
          Staffing Registration Form
        </h3>
        <p style={{ fontSize: 14, color: "#16a34a", marginBottom: 8 }}>
          ✅ This form has been verified by admin. You cannot edit it.
        </p>
        <p style={{ fontSize: 13, color: "#4b5563", marginBottom: 12 }}>
          If anything needs changing, please contact the office.
        </p>
        {/* You can later show a read-only summary here if you like */}
      </div>
    );
  }

  return (
    <div style={{ padding: 16, maxWidth: 800, margin: "0 auto" }}>
      <StaffRegistrationFormShort onSubmit={handleSubmit} initialData={existingDoc} />
    </div>
  );
}
